<template>
  <b-modal id="modal-visualiza-imagem" dialog-class="modal-conta" size="lg" hide-footer :no-enforce-focus="true">
    <template slot="modal-header">
      <h5 class="modal-title">Visualiza imagem</h5>
      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-visualiza-imagem')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <form>
      <h6><i class="fas fa-key"></i> Dados da imagem atual</h6>
      <div class="row">
        <div class="col-md-12 mb-3">
          <h3> {{ imagemVisualizar }} </h3>
          <img :src="obterUrlS3(imagemVisualizar)" width="50%" v-if="mostrarImagem" @error="imagemErro">
          <i class="fas fa-9x fa-exclamation-circle" v-else v-b-tooltip.hover title="Imagem não encontr-ada"></i>
        </div>
      </div>
      <p></p>
      Link: <a target="_blank" :href="obterUrlS3(imagemVisualizar)">{{imagemVisualizar.url}}</a>
       <div class="text-center">
        <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
          <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-visualiza-imagem')">Cancelar</a>
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
// import UrlUtils from '@/core/util/url-utils'

export default {
  name: 'ModalVisualizaImagem',
  inheritAttrs: false,
  props: {
    imagemVisualizar: String
  },
  data () {
    return {
      imagem: String,
      mostrarImagem: true
    }
  },

  mounted () {
    this.$root.$on('bv::modal::show', () => {
      this.imagem = this.imagemVisualizar
    })
    this.mostrarImagem = true
  },

  methods: {
    show: function () {
      this.$bvModal.show('modal-visualiza-imagem')
    },

    obterUrlS3: function (imagem) {
      return 'https://jaleko-files.s3-sa-east-1.amazonaws.com/desenvolvimento/jaleklinicos/001.JPG'
      // return UrlUtils.obterUrlS3('topicos-imagem/' + imagem.url)
    },

    imagemErro () {
      this.mostrarImagem = false
    }
  }
}
</script>
<style>
  div.modal-conta i.glyphicon-calendar{
    font-size: inherit;
  }
</style>
